module.exports = __webpack_public_path__ + "static/media/computer.4d396bf6.svg";